import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataExon = localStorage.getItem("userDataExon") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon")))) : "";

var serviceName = "sayfa";
var sayfaService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/enkucuk/",
    path  : "https://www.exonbiyotek.com/",
    sayfaTree() {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                methodName: "sayfaTree"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sayfaTanimlama(ustsayfaId, menuGorunum, link, seoBaslik, seoIcerik, baslik, altBaslik,buton,butonLink,video, icerik,icon, belgeList, resimList, resimKonum, menuKonum, galeriKonum, durum,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                ustsayfaId: ustsayfaId,
                menuGorunum: menuGorunum,
                link: link,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                baslik: baslik,
                altBaslik: altBaslik,
                buton: buton,
                butonLink: butonLink,
                video: video,
                icerik: icerik,
                icon: icon,
                belgeList: belgeList,
                resimList: resimList,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                durum: durum,
                dil: dil,
                methodName: "sayfaTanimlama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    sayfaCount(durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                methodName: "count"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sayfaListesi(durum, baslangic, limit,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                dil: dil,
                methodName: "sayfaListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sayfaDurumGuncelle(sayfaId, durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                sayfaId: sayfaId,
                durum: durum,
                methodName: "sayfaDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sayfaDetay(sayfaId, dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                sayfaId : sayfaId ,
                dil : dil ,
                methodName: "sayfaDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sayfaGuncelle(sayfaId, updateList) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                sayfaId: sayfaId,
                updateList: updateList,
                methodName: "sayfaGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
    
}

export default sayfaService

